import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=47dd2d4d&scoped=true&"
import script from "./digital.vue?vue&type=script&lang=js&"
export * from "./digital.vue?vue&type=script&lang=js&"
import style0 from "./digital.vue?vue&type=style&index=0&id=47dd2d4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd2d4d",
  null
  
)

export default component.exports